/**
 * @param (accountSelection) used for kickoff step
 * @param (contribution) used to determine contribution workflow
 * @param (accountSelection) used to determine distribution workflow
 * @param (reallocation) used to determine model-change/reallocation workflow
 * @param (closeAccount) used to determine close account workflow
 * @param (generalAccount) used to determine general message/upload workflow
 * @param (reallocationV2) used to determine the V2 reallocation wizard (ACMTECH-902)
 * @param (contributionV2) used to determine the V2 contribution wizard (ACMTECH-887)
 * @param (distributionV2) used to determine the V2 distribution wizard, incl. Close Account (ACMTECH-888)
 */
export enum RequestTypeEnum {
  accountSelection,
  closeAccount,
  contribution,
  distribution,
  planningDesk,
  reallocation,
  generalAccount,
  initialAccountSetup,
  /**
   * The V2 reallocation wizard. Needs its own member rather than reusing
   * `reallocation`, which the v1 free-text workflow still owns while both run
   * side by side. Appended so no existing member is renumbered — the ordinals are
   * the nav list's `order` and the modal's body discriminator.
   */
  reallocationV2,
  /**
   * The V2 Contribution wizard (ACMTECH-887). Its own member rather than reusing
   * `contribution`, which the v1 workflow still owns while both run side by side.
   */
  contributionV2,
  /**
   * The V2 Distribution wizard (ACMTECH-888), which also files Close Account via a
   * checkbox rather than as a separate request type. Its own member rather than reusing
   * `distribution`, which the v1 workflow still owns.
   *
   * ⚠️ Deliberately NOT a separate `closeAccountV2` member: closing is a distribution
   * with `IsCloseAccount` set, so it is one wizard, one tile and one payload — and one
   * enum member, or the tile would have to guess which the advisor meant.
   */
  distributionV2,
}

export enum AccountUpdateStepEnum {
  step1 = 1,
  step2 = 2,
  step3 = 3,
  step4 = 4,
  step5 = 5,
}